import { RouteRecordRaw } from 'vue-router';
import UserProfileLayout from '@/components/tailwind/layout/user/UserProfileLayout.vue';
import NoHeaderLayout from '@/components/layout/NoHeaderLayout.vue';
import UserProfileManagerLayout from '@/components/layout/UserProfileManagerLayout.vue';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/profile/settings',
    name: 'UserProfileManagerPage',
    meta: {
      layout: UserProfileLayout,
      accessWithSession: true,
      useTailwind: true,
    },
    component: () => import(/* webpackChunkName: "userProfile" */ '@/views/tailwind/user/UserProfileView.vue'),
  },
  {
    path: '/profile/settings/address',
    name: 'UserAddressesPage',
    meta: {
      layout: NoHeaderLayout,
      accessWithSession: true,
      useTailwind: false,
    },
    component: () => import(/* webpackChunkName: "userManager" */ '@/views/user/UserAddressesView.vue'),
  },
  {
    path: '/profile/settings/address/add',
    name: 'UserAddressCreatePage',
    meta: {
      layout: NoHeaderLayout,
      accessWithSession: true,
      useTailwind: false,
    },
    component: () => import(/* webpackChunkName: "userManager" */ '@/views/user/UserAddressesCreateView.vue'),
  },
  {
    path: '/profile/settings/payment-methods',
    name: 'UserPaymentMethodsPage',
    meta: {
      layout: UserProfileManagerLayout,
      accessWithSession: true,
      useTailwind: false,
    },
    component: () => import(/* webpackChunkName: "userManager" */ '@/views/user/UserPaymentMethodsView.vue'),
  },
  {
    path: '/profile/settings/notifications',
    name: 'UserNotificationsPage',
    meta: {
      layout: UserProfileManagerLayout,
      accessWithSession: true,
      useTailwind: false,
    },
    component: () => import(/* webpackChunkName: "userManager" */ '@/views/user/UserNotificationsView.vue'),
  },
];

export default routes;
